export default __webpack_public_path__ + "static/media/ic_liberia.2c499ba6.svg";